(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('ConsumerComplaintDetailController', ConsumerComplaintDetailController);

  /* ngInject */
  function ConsumerComplaintDetailController($stateParams, Flash, consumerComplaintService, consumerComplaintSearchService, sessionService) {
    const vm = this;

    vm.consumerComplaint = {};
    vm.consumerComplaintSearch = {};
    vm.updateConsumerComplaint = updateConsumerComplaint;

    activate();

    function activate() {
      getConsumerComplaint();
      getConsumerComplaintSearch();
    }

    function getConsumerComplaint() {
      consumerComplaintService(sessionService.getAuthToken()).get({ consumer_complaint_search_id: $stateParams.consumer_complaint_search_id, id: $stateParams.id }, response => {
        vm.consumerComplaint = response;
      });
    }

    function getConsumerComplaintSearch() {
      consumerComplaintSearchService(sessionService.getAuthToken()).get({ id: $stateParams.consumer_complaint_search_id }, response => vm.consumerComplaintSearch = response);
    }

    function updateConsumerComplaint() {
      consumerComplaintService(sessionService.getAuthToken()).update({ consumer_complaint_search_id: $stateParams.consumer_complaint_search_id, id: $stateParams.id }, vm.consumerComplaint, _ => {
        Flash.create('success', 'Consumer complaint notes successfully updated.'); 
      }, _ => {
        Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
      }); 
    }
  }
})();
